import { render } from "./ChatMessageComposer.vue?vue&type=template&id=21812c0c&scoped=true"
import script from "./ChatMessageComposer.vue?vue&type=script&lang=ts"
export * from "./ChatMessageComposer.vue?vue&type=script&lang=ts"

import "./ChatMessageComposer.vue?vue&type=style&index=0&id=21812c0c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-21812c0c"

export default script